import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import { applyRouteSeo } from '@/utils/seo';

Vue.use(VueRouter);

// ── Tab pages (kept alive) ──
const HomePage = () => import('@/views/HomePage.vue');
const NearbyPage = () => import('@/views/NearbyPage.vue');
const PublishPage = () => import('@/views/PublishPage.vue');
const WantedListPage = () => import('@/views/WantedListPage.vue');
const ProfilePage = () => import('@/views/ProfilePage.vue');

// ── Stack pages ──
const LoginPage = () => import('@/views/LoginPage.vue');
const RegisterPage = () => import('@/views/RegisterPage.vue');
const ProductDetailPage = () => import('@/views/ProductDetailPage.vue');
const UserProfilePage = () => import('@/views/UserProfilePage.vue');
const EditProfilePage = () => import('@/views/EditProfilePage.vue');
const AccountSettingsPage = () => import('@/views/AccountSettingsPage.vue');
const IdentityVerifyPage = () => import('@/views/IdentityVerifyPage.vue');
const ChangePasswordPage = () => import('@/views/ChangePasswordPage.vue');
const ForgotPasswordPage = () => import('@/views/ForgotPasswordPage.vue');
const MessagesPage = () => import('@/views/MessagesPage.vue');
const MessageDetailPage = () => import('@/views/MessageDetailPage.vue');
const MyProductsPage = () => import('@/views/MyProductsPage.vue');
const MyWantedPage = () => import('@/views/MyWantedPage.vue');
const MyFavoritesPage = () => import('@/views/MyFavoritesPage.vue');
const MyFollowsPage = () => import('@/views/MyFollowsPage.vue');
const PublishSuccessPage = () => import('@/views/PublishSuccessPage.vue');
const CategoryBrowsePage = () => import('@/views/CategoryBrowsePage.vue');
const LocationPickerPage = () => import('@/views/LocationPickerPage.vue');
const WantedPublishPage = () => import('@/views/WantedPublishPage.vue');
const HelpCenterPage = () => import('@/views/HelpCenterPage.vue');
const HelpListPage = () => import('@/views/HelpListPage.vue');
const HelpDetailPage = () => import('@/views/HelpDetailPage.vue');
const HelpTradePage = () => import('@/views/HelpTradePage.vue');
const HelpSecurityPage = () => import('@/views/HelpSecurityPage.vue');
const HelpRulesPage = () => import('@/views/HelpRulesPage.vue');
const GuideListPage = () => import('@/views/GuideListPage.vue');
const GuideDetailPage = () => import('@/views/GuideDetailPage.vue');
const FeedbackPage = () => import('@/views/FeedbackPage.vue');
const PrivacyPage = () => import('@/views/PrivacyPage.vue');

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  // Tab pages
  { path: '/home', name: 'home', component: HomePage, meta: { tab: 'home', keepAlive: true } },
  { path: '/nearby', name: 'nearby', component: NearbyPage, meta: { tab: 'nearby', keepAlive: true } },
  { path: '/publish', name: 'publish', component: PublishPage, meta: { tab: 'publish', keepAlive: true, hideTabbar: true } },
  { path: '/wanted-list', name: 'wanted-list', component: WantedListPage, meta: { tab: 'wanted-list', keepAlive: true } },
  { path: '/profile', name: 'profile', component: ProfilePage, meta: { tab: 'profile', keepAlive: true } },
  // Stack pages
  { path: '/login', name: 'login', component: LoginPage, meta: { stack: true } },
  { path: '/register', name: 'register', component: RegisterPage, meta: { stack: true } },
  { path: '/product-detail', name: 'product-detail', component: ProductDetailPage, meta: { stack: true } },
  { path: '/user-profile', name: 'user-profile', component: UserProfilePage, meta: { stack: true } },
  { path: '/edit-profile', name: 'edit-profile', component: EditProfilePage, meta: { stack: true } },
   { path: '/account-setting', name: 'account-setting', component: AccountSettingsPage, meta: { stack: true } },
  { path: '/identity-verify', name: 'identity-verify', component: IdentityVerifyPage, meta: { stack: true } },
  { path: '/change-password', name: 'change-password', component: ChangePasswordPage, meta: { stack: true } },
  { path: '/forgot-password', name: 'forgot-password', component: ForgotPasswordPage, meta: { stack: true } },
  { path: '/messages', name: 'messages', component: MessagesPage, meta: { stack: true } },
  { path: '/message-detail', name: 'message-detail', component: MessageDetailPage, meta: { stack: true } },
  { path: '/my-products', name: 'my-products', component: MyProductsPage, meta: { stack: true } },
  { path: '/my-wanted', name: 'my-wanted', component: MyWantedPage, meta: { stack: true } },
  { path: '/my-favorites', name: 'my-favorites', component: MyFavoritesPage, meta: { stack: true } },
  { path: '/my-follows', name: 'my-follows', component: MyFollowsPage, meta: { stack: true } },
  { path: '/publish-success', name: 'publish-success', component: PublishSuccessPage, meta: { stack: true } },
  { path: '/category-browse', name: 'category-browse', component: CategoryBrowsePage, meta: { stack: true } },
  { path: '/location-picker', name: 'location-picker', component: LocationPickerPage, meta: { stack: true } },
  { path: '/wanted-publish', name: 'wanted-publish', component: WantedPublishPage, meta: { stack: true } },
  { path: '/help-center', name: 'help-center', component: HelpCenterPage, meta: { stack: true } },
  { path: '/help-list', name: 'help-list', component: HelpListPage, meta: { stack: true } },
  { path: '/help-detail', name: 'help-detail', component: HelpDetailPage, meta: { stack: true } },
  { path: '/help-trade', name: 'help-trade', component: HelpTradePage, meta: { stack: true } },
  { path: '/help-security', name: 'help-security', component: HelpSecurityPage, meta: { stack: true } },
  { path: '/help-rules', name: 'help-rules', component: HelpRulesPage, meta: { stack: true } },
  { path: '/guide-list', name: 'guide-list', component: GuideListPage, meta: { stack: true } },
  { path: '/guide-detail', name: 'guide-detail', component: GuideDetailPage, meta: { stack: true } },
  { path: '/feedback', name: 'feedback', component: FeedbackPage, meta: { stack: true } },
  { path: '/privacy', name: 'privacy', component: PrivacyPage, meta: { stack: true } },
  // Catch-all
  { path: '*', redirect: '/home' }
];

const router = new VueRouter({
  // hash 模式：刷新只请求域名根路径，避免 Nginx/静态托管下 history 直出 404
  mode: 'history',
  base: '/',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.meta.stack) {
      return false;
    }
    if (savedPosition) {
      return savedPosition;
    }
    if (to.meta.tab && (from.meta.tab || from.meta.stack)) {
      return false;
    }
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  if (to.name === 'publish' && !store.isLoggedIn) {
    sessionStorage.setItem('pendingToast', '未登录，请先登录');
    const fallback = from.name && from.name !== 'publish' ? from.name : 'home';
    next({ name: fallback, replace: true });
    return;
  }
  next();
});

router.afterEach((to) => {
  applyRouteSeo(to);
});

export default router;
